import { Component, OnDestroy, OnInit } from '@angular/core';
import { from, Subscription } from 'rxjs';
import { ContextService } from '../../services/context/context.service';
import { DataService } from '../../services/context/data.service';
import { UIStateService } from '../../services/context/uistate.service';
import * as fromModel from '../../services/models';
import { MatDialog } from '@angular/material/dialog';
import { EditClientComponent } from '../edit-client/edit-client.component';
import { Utils } from 'projects/gpt/src/utils/utils';
import { timestamp } from 'rxjs/operators';

@Component({
  selector: 'gp-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss']
})
export class ClientListComponent implements OnInit, OnDestroy {

  plan: fromModel.Plan;
  planClients: fromModel.PlanClient[];

  clientsMenuItems: any[] = [];
  allClients: any[];
  showAddPerson = false;
  isDataChanged = false;
  showSearch = false;

  //protected _storeAppContextSubscription: Subscription;
  protected _storeDataSubscription: Subscription;
  

  constructor(private contextService: ContextService,
              private uiStateService: UIStateService,  
              private dataService: DataService,
              private dialog: MatDialog) { 
    //this._storeAppContextSubscription = this.contextService.subscribe((appContext:fromModel.IAppContext) => this.populateAppContext(appContext));
    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));   
  }

  ngOnInit(): void {
    this.plan = this.dataService.appData.Plan;
    this.loadClientMenu();
    // this.allClients = this.dataService.getAllClients();
    // this.prepareClientMenu();
  }

  populateAppData(appData: fromModel.IAppData){  
    if(appData && appData.action !== fromModel.DATA_ACTION.NONE){
    //   this.allClients = this.dataService.getAllClients();
    // this.prepareClientMenu();
      this.plan = <fromModel.Plan>appData.Plan;
      if(this.plan && this.plan.planClients && this.plan.planClients.length>0){
        this.planClients = this.plan.planClients; 
        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "ClientListComponent-populateAppData", false);
        // let _pClient = this.planClients.find(_c=>_c.role === fromModel.CLIENTROLE.Primary);
        // if(_pClient){
        //   _pClient.clientName
        // }      
      }
    } 

    if(appData.action && appData.action === fromModel.DATA_ACTION.SELECTEDPLANCLIENT){
      this.prepareClientMenu();
    }
  }

  prepareClientMenu(){
    this.clientsMenuItems = [];
    let subMenuClientItems = []; 
    if(this.allClients && this.allClients.length>0){      
        if(!this.dataService.getClientByRole(fromModel.CLIENTROLE.Secondary)){
          subMenuClientItems = this.prepareClientSubMenu(fromModel.CLIENTROLE.Secondary);
          subMenuClientItems.push({role: fromModel.CLIENTROLE.Secondary, clientid:'', clientname:'Search'});
          if(subMenuClientItems.length>0){
            this.clientsMenuItems.push({displayClientTypeName: `Add Spouse`, type: fromModel.CLIENTROLE.Secondary, subMenuItems: subMenuClientItems});
          }
        } 
        subMenuClientItems=this.prepareClientSubMenu(fromModel.CLIENTROLE.Other);
        if(subMenuClientItems.length>0){
          this.clientsMenuItems.push({displayClientTypeName: `Add Other `, type: fromModel.CLIENTROLE.Other, subMenuItems: subMenuClientItems});
        }
    } else {
      if(!this.dataService.getClientByRole(fromModel.CLIENTROLE.Secondary)){
        let subMenuClientItems = []; 
        subMenuClientItems.push({role: fromModel.CLIENTROLE.Secondary, clientid:'', clientname:'Search'});
        this.clientsMenuItems.push({displayClientTypeName: `Add Spouse`, type: fromModel.CLIENTROLE.Secondary, subMenuItems: subMenuClientItems});
      }
    }

    if(this.clientsMenuItems.length>0){
      this.showAddPerson = true;
    } else {
      this.showAddPerson = false;
    }
    
  }

  loadClientMenu(){
    this.allClients = this.dataService.getAllClients();
    this.prepareClientMenu();
  }

  // prepareClientSubMenu(role: fromModel.CLIENTROLE){
  //   let subMenuClientItems = []; 
  //   this.allClients.forEach(cl => {
  //     let subMenuItem = { 
  //       role: role,             
  //       clientid: cl.LegalEntityID,
  //       clientname: cl.LegalEntityName        
  //     }; 
  //     subMenuClientItems.push(subMenuItem);      
  //   });
  //   return subMenuClientItems;
  // }

  // prepareSecondaryClientSubMenu(){
  //   let subMenuClientItems = []; 
  //   if(!this.dataService.getClientByRole(fromModel.CLIENTROLE.Secondary)){
  //     this.allClients.forEach(cl => {
  //       let subMenuItem = { 
  //         role: fromModel.CLIENTROLE.Other,             
  //         clientid: cl.LegalEntityID,
  //         clientname: cl.LegalEntityName        
  //       }; 
  //       subMenuClientItems.push(subMenuItem);
  //     });
  //   }
  //   return subMenuClientItems;
  // }


  // prepareOtherClientSubMenu(){
  //   let subMenuClientItems = []; 
  //   this.allClients.forEach(cl => {
  //     let plCl =  this.planClients.find(plcl=>plcl.clientid === cl.LegalEntityID);
  //     if(!plCl){
  //       let subMenuItem = { 
  //         role: fromModel.CLIENTROLE.Other,             
  //         clientid: cl.LegalEntityID,
  //         clientname: cl.LegalEntityName        
  //       }; 
  //       subMenuClientItems.push(subMenuItem);  
  //     }         
  //   });
  //   return subMenuClientItems;
  // }

  prepareClientSubMenu(role){
    let subMenuClientItems = []; 
    this.allClients.forEach(cl => {
      
        let plCl =  this.planClients.find(plcl=>plcl.clientid === cl.LegalEntityID);
        if(!plCl){
          let subMenuItem = { 
            role: role,             
            clientid: cl.LegalEntityID,
            clientname: cl.LegalEntityName, 
            legalEntityType: cl.legalEntityType
          }; 
          if(role === fromModel.CLIENTROLE.Secondary && cl.legalEntityType.toUpperCase() == "INDIVIDUAL"){
            subMenuClientItems.push(subMenuItem);  
          } else if(role !== fromModel.CLIENTROLE.Secondary) {
            subMenuClientItems.push(subMenuItem);  
          }
        }  
      
    });
    return subMenuClientItems;
  }

  saveSelectedClients(){
    if(this.isDataChanged){
      this.dataService.dispatchAction(fromModel.DATA_ACTION.ACCOUNTS, "ClientListComponent-saveSelectedClients", null);
      this.dataService.savePlan();    
      this.dataService.setClientInContext();
      this.isDataChanged = false;
    } else {
      this.dataService.savePlan(); 
    }
    
  }

  
  
  addClient(role, clientid){      
    this.showSearch  = false;  
    if(role === fromModel.CLIENTROLE.Secondary){
      if(clientid){
        this.openModelDialog(fromModel.OPENDIALOGACTIONS.EDITCLIENT, role, clientid);
      } else {
        this.showSearch = true;
      }
    } else {
      this.isDataChanged = true;
      this.dataService.dispatchAction(fromModel.DATA_ACTION.SELECTEDPLANCLIENT, "ClientListComponent-addClient", {clientid: clientid});
    }
    
  }

  onSearchSelection(selection: any){
    let searchClient;
    if(selection && selection.searchType === 'client'){
      searchClient = {clientid: selection.searchResult.LegalEntityID, 
              clientname: selection.searchResult.LegalEntityName, 
              dob: selection.searchResult.dateofBirth,
              age: Utils.calculateAge(selection.searchResult.dateofBirth)
      };
      this.openModelDialog(fromModel.OPENDIALOGACTIONS.EDITCLIENT, fromModel.CLIENTROLE.Secondary, selection.searchResult.LegalEntityID, searchClient);
    } else if(selection && selection.searchType === 'account'){
      searchClient = {clientid: selection.searchResult.LegalEntityID, 
        clientname: selection.searchResult.LegalEntityName, 
        dob: selection.searchResult.dateofBirth, 
        age: Utils.calculateAge(selection.searchResult.dateofBirth)
      };
      this.openModelDialog(fromModel.OPENDIALOGACTIONS.EDITCLIENT, fromModel.CLIENTROLE.Secondary, selection.searchResult.LegalEntityID, searchClient);
    } else if(selection && selection.searchType === 'closeSearch'){
      this.showSearch = false;
    }
  }

  openModelDialog(action: fromModel.OPENDIALOGACTIONS, parm1?: string, parm2?: string, parm3?: any){
    switch(action){
      case fromModel.OPENDIALOGACTIONS.EDITCLIENT: {
        const dialogRef = this.dialog.open(EditClientComponent, {
          width: '35%',
          height: '55%',
          data: {mode: 'add', role: parm1, clientid: parm2, searchClient: parm3},          
          disableClose: true    
          }).afterClosed()
          .subscribe(result => {     
            if(result.isSaved){
              //this.isDataChanged = true;  
              this.showSearch = false;
              // this.allClients = this.dataService.getAllClients();
              // this.prepareClientMenu();
            }
          });        
        break;
      }     
    }
  }

  ngOnDestroy(): void{
    // if(this._storeAppContextSubscription && this._storeAppContextSubscription !== null){
    //   this._storeAppContextSubscription.unsubscribe();
    // }
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }    
    // if(this._uiStateSubscription && this._uiStateSubscription !== null){
    //   this._uiStateSubscription.unsubscribe();    
    // }
  }
}
